export const isDCDAvailable = (store) => store.AllowDuc;
export const isCarryoutAvailable = (store) => store.AllowCarryoutOrders;
export const isDeliveryAvailable = (store) => store.AllowDeliveryOrders;
export const isPickupAvailable = (store) => store.AllowPickupWindowOrders;
